import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'
import Sticky from 'components/Sticky'

export const StickyFooter = () => (
  <Sticky hasBgTransparent>
    <div className='container'>
      <div className='row no-gutters d-flex justify-content-center mc-mb-8'>
        <div className='col-12 col-xl-9'>
          <div
            className='mc-corners--md'
            style={{
              background: 'rgba(0, 0, 0, 0.30)',
              backdropFilter: 'blur(20px)',
            }}
          >
            <MobileContent />
            <DesktopContent />
          </div>
        </div>
      </div>
    </div>
  </Sticky>
)

const MobileContent = () => (
  <div className='d-flex d-md-none align-items-center justify-content-end mc-px-2 mc-py-4'>
    <p className='mc-text-x-small'>
      <PricingText
        isStickyFooter
        isStickyFooterMoneyBackExperiment
        className='mc-mr-4'
        translationKey='pen-5613_v1-cm-timeline-view-sticky-footer'
      >
        <span className='mc-text--bold' />
      </PricingText>
    </p>
    <CTA size='sm' className='mc-px-3' />
  </div>
)

const DesktopContent = () => (
  <div className='d-none d-md-flex align-items-center justify-content-end mc-p-4'>
    <p>
      <PricingText
        isStickyFooter
        isStickyFooterMoneyBackExperiment
        className='mc-mr-4'
        translationKey='pen-5613_v1-cm-timeline-view-sticky-footer'
      >
        <span className='mc-text--bold' />
      </PricingText>
    </p>
    <div>
      <CTA />
    </div>
  </div>
)
